import React, { useEffect, useState } from "react";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import Icon from "components/MainApp/atoms/Icon/icon";
import BarcodeImg from "./CodigoBarras.svg";
import styles from "./MainApp.organisms.OrdersV3.Tag.module.scss";
import { isMobile } from "helpers/Mobile";
import { useHistory } from "react-router-dom";
import i18n from "i18n";

const Item = ({
  tag,
  epc,
  handleDelete,
  handleSelect,
  selected,
  type,
  message = null,
  tagsInMov = [],
  reprint,
  handleUpdateFoundStatus
}) => {
  const history = useHistory();

  const [isHandled, setIsHandled] = useState(false);

  useEffect(() => {
    // Check if the tag has already been handled.
    if (isHandled || message !== null) return;

    if (
      selected &&
      message === null &&
      typeof handleUpdateFoundStatus === "function"
    ) {
      // If the tag is selected and does not have a message, we update the found_status in the parent component.
      handleUpdateFoundStatus(tag);
      setIsHandled(true); // Mark as handled
    }
  }, [selected, message, tag, handleUpdateFoundStatus, isHandled]);

  return (
    <div className={styles["tag-container"]}>
      <div className={styles["left-container"]}>
        {handleSelect && (
          <div
            className={styles["tag-selector"]}
            onClick={() => handleSelect(tag)}
          >
            <Checkbox checked={selected} />
          </div>
        )}
        <div className={styles["tag"]}>
          <div className={styles["tag-number"]}>
            <div className={styles["tag-info"]}>
              {tag.tag} {tag.type}
            </div>
            <div
              className={` ${styles["icon-reprint"]} icon-reprint`}
              onClick={() => {
                history.push(`/admin/tags/reprint/${tag.tag}`);
              }}
            >
              {reprint && !isMobile && (
                <Icon
                  className={styles["icon-reprint"]}
                  name={"dispositivos"}
                  fill={"#3C7AF5"}
                  width={23}
                  height={27}
                />
              )}
            </div>
          </div>
          {epc && (
            <div className={styles["tag-rfid"]}>
              <div
                className={styles["icon-reprint"]}
                onClick={() => {
                  history.push(`/admin/tags/reprint/${tag.tag}`);
                }}
              >
                {reprint && isMobile && (
                  <Icon
                    className={styles["icon-reprint"]}
                    name={"dispositivos"}
                    fill={"#3C7AF5"}
                    width={23}
                    height={27}
                  />
                )}
              </div>
            </div>
          )}
          {/* {tag.barcode && (
            <>
              <img src={BarcodeImg} />
              <div className={styles["barcode"]}>{tag.barcode}</div>
            </>
          )} */}
          {tagsInMov.includes(tag.tag) && (
            <div className={styles["note_process_order"]}>
              {i18n.t("tag.in.process")}
            </div>
          )}
        </div>
      </div>

      {message && (
        <div>
          <p className={styles["pmessage"]}>{message}</p>
        </div>
      )}

      {handleDelete && (
        <div onClick={() => handleDelete(tag)}>
          <Icon name="trash_can" width={20} height={20} fill={"#3C7AF5"} />
        </div>
      )}
      {type === "verification" &&
        message === null &&
        selected &&
        !handleSelect &&
        !handleDelete && (
          <Icon name="check" width={20} height={20} fill={"#62d862"} />
        )}
      {type === "verification" &&
        message === null &&
        selected === false &&
        !handleSelect &&
        !handleDelete && (
          <Icon name="close" width={20} height={20} fill={"red"} />
        )}
    </div>
  );
};

export default Item;
